var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('div',{ref:"backgroundWrapper",staticClass:"responsive-image__media"},[_c('div',{ref:"parallax",staticClass:"parallax",class:[_vm.isParallaxActive ? 'active' : ''],style:(_vm.parallaxCss)}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }